import { Grid } from "@mui/material";
import React from "react";
import { getAssets } from "@unisearch/helpers";
import styles from "./administration.module.scss";

export const UniPageAnalyticsAdministration = () => {
  return (
    <section className={styles.section_administration}>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_administration.png")}
                alt="Data metrics"
              />
            </div>
          </Grid>

          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>All-Around Administration</h2>
            <p className={`${styles.sub_title} font-medium`}>
              We cover all the bases for successful student recruitment through
              a single platform - meaning you can track a student’s progress
              from the research stage down to the application and acceptance
              stage and beyond.
            </p>
            <p className={`${styles.sub_title} font-medium`}>
              By eliminating the detours and middle-men in the process, you know
              at all times which students are most likely to convert, actively
              assist during application progress, and track application
              completion, all in real-time.
            </p>
            <p className={`font-medium`}>
              You have much more control over the recruitment process, allowing
              you to adjust strategies and goals right away to meet target
              outcomes.
            </p>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageAnalyticsAdministration;
